import styled from 'styled-components';

export const Container = styled.div`
  max-width: 900px;
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-end;

  gap: 3.12rem;

  margin-bottom: 10px;
`;
